 
/**
 * 根据宽度和款宽高比算出高度
 * @param {*} width 宽度
 * @param {*} ratio 比例
 */
const ratio = {
  homeBanner: {
    name: "首页banner",
    width: 1920,
    height: 460,
  },
  openCourse: {
    name: "公开课",
    width: 750,
    height: 500,
  },
  newUserGift: {
    name: "新用户礼包",
    width: 750,
    height: 500,
  },
  exam: {
    name: "营销考场",
    width: 750,
    height: 500,
  },
};
export const setImgHeight = (width, key) => {
  if (!key || !ratio[key]) return 0;
  return (ratio[key].height / ratio[key].width) * width;
};

// 防抖
export const debounce = (fn, duration = 200) => {
  let timer = null;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, duration);
  };
};

// 节流
export const throttle = (fn, wait = 800) => {
  let previous = 0;
  return function () {
    let now = +new Date();
    if (now - previous > wait) {
      fn.apply(this, arguments);
      previous = now;
    }
  };
};

// 禁止滑动
const bodyStyle = `
  width:100%;
  position:fixed;
  left:0;
  top:0;
  display:flex;
  justify-content:center;
`;
const appStyle = `
  width:100%;
`;
export const setStyleFixed = () => {
  const body = document.getElementsByTagName("body")[0];
  const bodyStyleContent = body.getAttribute("style");
  body.setAttribute("style", bodyStyleContent ? bodyStyleContent + bodyStyle : bodyStyle);

  const app = document.getElementById("app");
  const appStyleContent = app.getAttribute("style");
  app.setAttribute("style", appStyleContent ? appStyleContent + appStyle : appStyle);
};
// 允许滑动
export const exitStyleFixed = () => {
  const body = document.getElementsByTagName("body")[0];
  body.setAttribute("style", "zoom: 1");

  const app = document.getElementById("app");
  app.setAttribute("style", "");
};

// 公共类
export class PublicClass {
  #events = {};
  $on(name, fn) {
    if (!name) return;
    this.#events[name] = fn;
  }

  $emit(name, val) {
    if (!name) return;
    this.#events[name] && this.#events[name](val);
  }

  $off(name) {
    if (name) {
      delete this.#events[name];
    } else {
      this.#events = {};
    }
  }
}

// 跳转班型详情
export const toClassDetails = (id, type) => {
  if (type == 1 || type == 2) {
    window.open(`/coachcourse/agreementClass?id=${id}`);
  } else {
    window.open(`/coachcourse/details?id=${id}`);
  }
};

// 我的作业-音频播放
class HomeworkAudio {
  audioInfo = {};

  audio = null;
  getAudio() {
    if (!this.audio) {
      this.audio = document.getElementById("homeworkAudio");

      this.audio.onplay = () => {
        this.audioInfo.isPlay = true;
      };
      this.audio.onpause = () => {
        this.audioInfo.isPlay = false;
        this.audioInfo = {};
      };
    }
  }
  play(info) {
    if (this.audioInfo.url && this.audioInfo.url != info.url) {
      this.audio.pause();
    }
    if (this.audioInfo.url == info.url) {
      this.audio.pause();
      return;
    }

    this.getAudio();

    setTimeout(() => {
      this.audioInfo = info;

      this.audio.src = info.url;
      this.audio.play();
    }, 10);
  }
  stop() {
    this.audio && this.audio.pause();
  }
}
export const homeworkAudio = new HomeworkAudio();

// 获取url参数
export function getUrlParams(urlStr) {
  if (typeof urlStr == "undefined") {
    // 获取url中"?"符后的字符串
    var url = decodeURI(location.search);
  } else {
    var url = "?" + urlStr.split("?")[1];
  }
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substring(1);
    let strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}

// 获取文件后缀名
export const getSuffix = (str) => {
  const suffix = str.split(".");
  return suffix[suffix.length - 1];
};

// 对象转换为以&拼接的字符串
export const setUrlParams = (obj) => {
  const arr = [];
  for (const key in obj) {
    let value = null;
    if (obj[key] != null && obj[key] != undefined) {
      if (Object.prototype.toString.call(obj[key]) === "[object Object]") {
        value = JSON.stringify(obj[key]);
      } else {
        value = obj[key];
      }
    }
    arr.push(`${key}=${value}`);
  }
  return arr.join("&");
};

// 题型
// 是否为客观题/主观题
function isQuestionType(type) {
  const index = this.list.findIndex((i) => i.type == type);
  return index != -1;
}
// 返回题型、方法
function questionFactory(name, list, obj) {
  return {
    name,
    list,
    ...obj,
    getList: function () {
      return this.list;
    },
    getName: function (type) {
      const item = this.list.find((i) => i.type == type);
      if (item) return item.name;
      return "";
    },
    getTypeList: function () {
      return this.list.map((i) => i.type);
    },
  };
}
export const questionType = {
  objective: questionFactory(
    "客观题",
    [
      {
        name: "单选题",
        type: 0,
      },
      {
        name: "多选题",
        type: 1,
      },
      {
        name: "判断题",
        type: 2,
      },
      {
        name: "不定项选择题",
        type: 6,
      },
    ],
    {
      isObjective: isQuestionType,
    }
  ),
  subjective: questionFactory(
    "主观题",
    [
      {
        name: "填空题",
        type: 3,
      },
      {
        name: "简答题",
        type: 4,
      },
      {
        name: "组合题",
        type: 5,
      },
    ],
    {
      isSubjective: isQuestionType,
    }
  ),
  getName: function (type) {
    const i = this.objective.list.find((i) => i.type == type);
    if (i) return i.name;
    const j = this.subjective.list.find((i) => i.type == type);
    if (j) return j.name;
  },
};

// 校验手机号
export const isPhone = (value) => {
  const reg = /^1[0-9]{10}$/;
  return reg.test(value);
};

// 动态加载外部链接
export function loadJS(url) {
  return new Promise((resolve) => {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    // IE
    if (script.readyState) {
      script.onreadystatechange = () => {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      // 其他浏览器
      script.onload = function () {
        resolve();
      };
    }
    document.getElementsByTagName("head")[0].appendChild(script);
  });
}

// 数字转汉字
export function numberToChinese(num) {
  var units = ["", "十", "百", "千", "万"];
  var nums = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  var str = ("" + num).split("");
  var result = "";

  for (var i = 0; i < str.length; i++) {
    var n = str[i];
    var unit = units[str.length - i - 1];
    result += nums[parseInt(n)] + unit;
  }

  result = result.replace(/零(千|百|十)/g, "零").replace(/零+/g, "零");
  result = result.replace(/零万/g, "万");
  result = result.replace(/零亿/g, "亿");
  result = result.replace(/零零/g, "零");
  result = result.replace(/亿万/g, "亿");
  result = result.replace(/零+$/, "");
  result = result.replace(/^一十/g, "十");

  return result;
}

/**
 * 画布-文字超出显示省略号
 * @param {*} canvas 画布实例
 * @param {*} text 文字
 * @param {*} x x坐标
 * @param {*} y y坐标
 * @param {*} maxWidth 最大宽度
 * @param {*} lineHeight 行高
 * @param {*} maxRowNum 最大行数
 */
export const setCanvasText = (canvas, text, x, y, maxWidth, lineHeight = 20, maxRowNum = 1) => {
  if (typeof text != "string" || typeof x != "number" || typeof y != "number") {
    return;
  }
  const arrText = text.split("");
  let line = "";
  let rowNum = 1;
  for (let n = 0; n < arrText.length; n++) {
    const testLine = line + arrText[n];
    const metrics = canvas.measureText(testLine);
    const testWidth = metrics.width;
    if (testWidth > maxWidth && n > 0) {
      if (rowNum >= maxRowNum) {
        const arrLine = testLine.split("");
        arrLine.splice(-2);
        let newTestLine = arrLine.join("");
        newTestLine += "...";
        canvas.fillText(newTestLine, x, y);
        return;
      }
      canvas.fillText(line, x, y);
      line = arrText[n];
      y += lineHeight;
      rowNum += 1;
    } else {
      line = testLine;
    }
  }
  canvas.fillText(line, x, y);
};

 
